import { buildDiagnosisResult } from './builders';
import type { DiagnosisResultContent } from './types';

/** PRLE（安定志向冒険家） */
const prleContent: DiagnosisResultContent = {
  code: 'PRLE',
  name: '安定志向冒険家',
  catchphrase: '計画はしっかり、でも冒険は外さない。安心の中で体験を深掘りする',
  rarity: 3,
  style:
    '「安全圏を保ちながら、じっくり体験を味わう」堅実な冒険派。事前に下調べと予約で土台を固めつつ、のんびりしたペースで現地の文化や食、自然に触れる。無茶な飛び込みはしないが、定番にとどまらず「ちょっと踏み込んだ体験」を計画的に組み込む。安心と冒険のバランスを知る、堅実な探究者タイプ。',
  strengths: [
    { lead: '安心して深掘りできる', text: '下調べ済みの土台の上で、体験に集中できる。' },
    { lead: '失敗リスクが低い', text: '無茶をせず、満足度の安定した冒険ができる。' },
    { lead: '同行者を安心させる', text: '計画があるので、一緒にいる人も心に余裕が生まれる。' },
  ],
  weaknesses: [
    { lead: '刺激は控えめ', text: '安全優先で、突拍子もない体験は少なめ。' },
    { lead: 'ペースが遅い', text: 'じっくり型ゆえ、回れる場所は限られる。' },
    { lead: '即興に弱い', text: '想定外の誘いに戸惑い、柔軟に乗り切れないことも。' },
  ],
  aaru: [
    { icon: 'camera', text: '下調べは丁寧、動きはゆったり' },
    { icon: 'msg', text: '「ちゃんと調べてきたよ」が口癖' },
    { icon: 'coffee', text: '定番＋αの体験を計画に入れる' },
    { icon: 'camera', text: '無理な飛び込みはしない' },
  ],
  manual: {
    good: '計画を尊重する／体験を一緒に味わう',
    ng: '「とりあえず行こう」で無計画に誘う',
    tips: '「安全が確認できた範囲で」の冒険なら乗りやすい',
  },
  compatibility: {
    good: 'PRCE（バランス）／PRCZ（快適派）',
    conflict: 'SALE（爆速即興）／SRLE（食い倒れ冒険）',
    tips: '体験の本命を1つ決めてから動くと満足度が高い',
  },
  destinations: {
    domestic: '京都（計画的に文化体験）／屋久島（自然を安心して深掘り）',
    overseas: '台湾（治安が良く体験豊富）／ニュージーランド（アクティビティが充実）',
  },
};

export const prleDiagnosisResult = buildDiagnosisResult(prleContent);
